function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Action, Placeholder, AuthoringMemo } from '../commons/IntlMessages';
import { Jodit } from "jodit";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);

var SPACE_REG_EXP = function SPACE_REG_EXP() {
  return /[\s\n\t\r\uFEFF\u200b]+/g;
}; // オーサリングメモ登録モーダル

/**
 * モード
 */


export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 編集
   */

  Mode[Mode["Edit"] = 2] = "Edit";
  /**
   * 表示のみ
   */

  Mode[Mode["ReadOnly"] = 3] = "ReadOnly";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Modal: null,
      Memo: _this.props.memo,
      MemoEditor: null,
      ErrorMessages: []
    };
    return _this;
  }
  /**
   * メモを更新します。
   *
   * @param e イベント
   */


  _createClass(MainComponent, [{
    key: "updateMemo",
    value: function updateMemo(e) {
      this.setState({
        Memo: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。44444
     */

  }, {
    key: "onEdit",
    value: function onEdit() {
      var _this2 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.MemoEditor != null) {
          var text = this.state.MemoEditor.text;
          var chars = text.replace(SPACE_REG_EXP(), '');

          if (chars.length > 200) {
            this.state.ErrorMessages.push(intl.format(Errors.InputWrongMaxLength, {
              title: intl.format(Label.Contents),
              length: "200"
            }));
          }
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        var memo = this.state.Memo;

        if (this.state.MemoEditor != null) {
          memo = this.state.MemoEditor.text;
        }

        this.props.onEdit(memo, function () {
          if (_this2.state.Modal == null) {
            throw Error();
          }

          _this2.state.Modal.modal('hide');
        });
      }
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onClose",
    value: function onClose() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var modal = $('#SessionAuthoringMemoDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      });
      var list = document.querySelectorAll(".modal-backdrop");

      for (var i = 0; i < list.length; i++) {
        if (!list[i].classList.contains("nested")) {
          list[i].classList.add("nested");
        }
      } // ポップアップが完全に非表示になった時のイベント。


      modal.on("hidden.bs.modal", function (e) {
        var list = document.querySelectorAll(".modal-backdrop");

        for (var i = 0; i < list.length; i++) {
          if (list[i].classList.contains("nested")) {
            list[i].classList.remove("nested");
          }
        }

        _this3.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");

      if (this.props.mode == Mode.ReadOnly) {
        this.setState({
          MemoEditor: new Jodit('#Memo', {
            theme: 'whiteroom',
            readonly: true,
            toolbar: false,
            enter: "BR",
            showCharsCounter: false,
            showWordsCounter: false,
            showXPathInStatusbar: false
          })
        });
      } else {
        this.setState({
          MemoEditor: new Jodit('#Memo', {
            theme: 'whiteroom',
            toolbar: false,
            enter: "BR",
            showWordsCounter: false,
            showXPathInStatusbar: false
          })
        });
      }
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionAuthoringMemoDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/information_icon_side.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringMemo.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("textarea", {
        className: "form-control",
        name: "Memo",
        id: "Memo",
        rows: 10,
        readOnly: true,
        value: this.state.Memo,
        tabIndex: 102
      }), this.props.mode != Mode.ReadOnly && [/*#__PURE__*/React.createElement("textarea", {
        className: "form-control",
        name: "Memo",
        id: "Memo",
        rows: 10,
        maxLength: 200,
        onChange: function onChange(e) {
          return _this4.updateMemo(e);
        },
        value: this.state.Memo,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Letters, {
          value: "200"
        })
      })])))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.props.mode == Mode.Edit && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEdit.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onClose.bind(this),
        tabIndex: -1
      }, intl.format(Action.Close))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };